
  import { mapGetters } from 'vuex';

  export default {
    props: {
      compareText: { type: String, default: null },
      customLink: { type: String, default: null },
      link: { type: String, required: true },
      product: { type: String, required: true }
    },
    computed: {
      ...mapGetters('providers', { providers: 'getList' }),
      isProviderLink () {
        return this.link.includes('providers') || this.link.includes('lenders');
      },
      textPath () {
        if (this.product === 'cards' || this.product === 'currents' || this.product === 'loans' || this.product === 'prepay-cards' || this.product === 'savings') {
          return 'banking';
        } else if (this.product === 'broadband') {
          return 'broadband';
        } else if (this.product === 'home-insurance') {
          return 'homeInsurance';
        } else if (this.product === 'car-insurance') {
          return 'carInsurance';
        } else if (this.product === 'life-insurance' || this.product === 'mortgage-protection' || this.product === 'serious-illness' || this.product === 'income-protection') {
          return 'insurance';
        } else if (this.product === 'mortgages') {
          return 'mortgages';
        }
        return '';
      }
    },
    methods: {
      providerPath (provider) {
        return this.$t(`productDisplayLabels.${this.product}.basePath`) + provider.slug;
      }
    }
  };
